import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction(
    'updateSelectedServiceCallIndexMutator',
    function updateSelectedServiceCallIndexMutator(newIndex: number) {
        getStore().selectedServiceCallIndex = newIndex;
    }
);
